import {Injectable} from '@angular/core';
import {Workflow} from '../../model/Workflow';

@Injectable({
  providedIn: 'root'
})
export class WorkflowDataService {

  private workflows: Workflow[] = [];

  setWorkflows(workflows: Workflow[]): void {
    this.workflows = workflows;
  }

  getWorkflows(): Workflow[] {
    return this.workflows;
  }

  clear(): void {
    this.workflows = [];
  }
}
